import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** "Someone removed me from friends" notification. Subject is the remover. */
export default class FriendshipRemovedNotification extends Notification {
  icon() {
    return 'fas fa-user-minus';
  }
  href() {
    const user = this.attrs.notification.subject();
    return user ? app.route.user(user) : '#';
  }
  content() {
    const fromUser = this.attrs.notification.fromUser();
    const data = this.attrs.notification.content() || {};
    const name = fromUser?.displayName() ?? data.removerName ?? '?';
    return app.translator.trans('forumaker-friendship.forum.notifications.removed_text', {
      name: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/FriendshipRemovedNotification', FriendshipRemovedNotification);